"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReleaseAlterationMutation = exports.useCancelAlterationMutation = exports.useUpdateAlterationMutation = exports.useFetchAlterationQuery = exports.useFetchApplicableAlterationsQuery = exports.useFetchAlterationsQuery = exports.useCreateAlterationMutation = exports.billingAlterationApi = void 0;
// api/billingAlterationApi.ts — IF-004.2 charge alterations.
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.billingAlterationApi = (0, react_1.createApi)({
    reducerPath: "billingAlterationApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["billingAlterations"],
    endpoints: function (builder) { return ({
        createAlteration: builder.mutation({
            query: function (obj) { return ({ url: "/v1/billing-alteration", method: "POST", body: obj }); },
            invalidatesTags: ["billingAlterations"],
        }),
        fetchAlterations: builder.query({
            query: function (params) { return ({ url: "/v1/billing-alteration/all", method: "GET", params: params }); },
            providesTags: ["billingAlterations"],
        }),
        fetchApplicableAlterations: builder.query({
            query: function (params) { return ({ url: "/v1/billing-alteration/applicable", method: "GET", params: params }); },
            providesTags: ["billingAlterations"],
        }),
        fetchAlteration: builder.query({
            query: function (id) { return ({ url: "/v1/billing-alteration/".concat(id), method: "GET" }); },
            providesTags: ["billingAlterations"],
        }),
        updateAlteration: builder.mutation({
            query: function (_a) {
                var id = _a.id, body = __rest(_a, ["id"]);
                return ({ url: "/v1/billing-alteration/".concat(id), method: "PATCH", body: body });
            },
            invalidatesTags: ["billingAlterations"],
        }),
        cancelAlteration: builder.mutation({
            query: function (_a) {
                var id = _a.id, body = __rest(_a, ["id"]);
                return ({ url: "/v1/billing-alteration/".concat(id, "/cancel"), method: "PATCH", body: body });
            },
            invalidatesTags: ["billingAlterations"],
        }),
        releaseAlteration: builder.mutation({
            query: function (_a) {
                var id = _a.id, body = __rest(_a, ["id"]);
                return ({ url: "/v1/billing-alteration/".concat(id, "/release"), method: "PATCH", body: body });
            },
            invalidatesTags: ["billingAlterations"],
        }),
    }); },
});
exports.useCreateAlterationMutation = exports.billingAlterationApi.useCreateAlterationMutation, exports.useFetchAlterationsQuery = exports.billingAlterationApi.useFetchAlterationsQuery, exports.useFetchApplicableAlterationsQuery = exports.billingAlterationApi.useFetchApplicableAlterationsQuery, exports.useFetchAlterationQuery = exports.billingAlterationApi.useFetchAlterationQuery, exports.useUpdateAlterationMutation = exports.billingAlterationApi.useUpdateAlterationMutation, exports.useCancelAlterationMutation = exports.billingAlterationApi.useCancelAlterationMutation, exports.useReleaseAlterationMutation = exports.billingAlterationApi.useReleaseAlterationMutation;
